/**
 * ArtifactLoading Component
 *
 * Estado de loading durante geração de artefato
 */

import React, { memo } from 'react';

// =============================================================================
// TYPES
// =============================================================================

interface ArtifactLoadingProps {
  type?: string;
  title?: string;
}

// =============================================================================
// COMPONENT
// =============================================================================

export const ArtifactLoading: React.FC<ArtifactLoadingProps> = memo(({ type, title }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8">
      {/* Spinner */}
      <div className="relative w-12 h-12 mb-6">
        <div className="absolute inset-0 border-2 border-white/10 rounded-full" />
        <div className="absolute inset-0 border-2 border-yellow-500 rounded-full border-t-transparent animate-spin" />
      </div>

      {/* Title */}
      <div className="text-center">
        <h3 className="text-white font-medium mb-2">
          {title || 'Gerando artefato...'}
        </h3>
        {type && (
          <p className="text-gray-400 text-sm">
            Tipo: {type}
          </p>
        )}
      </div>

      {/* Skeleton lines */}
      <div className="w-full max-w-md mt-8 space-y-3">
        <div className="h-4 bg-white/5 rounded animate-pulse" style={{ width: '100%' }} />
        <div className="h-4 bg-white/5 rounded animate-pulse" style={{ width: '85%' }} />
        <div className="h-4 bg-white/5 rounded animate-pulse" style={{ width: '92%' }} />
        <div className="h-4 bg-white/5 rounded animate-pulse" style={{ width: '78%' }} />
      </div>
    </div>
  );
});

ArtifactLoading.displayName = 'ArtifactLoading';

export default ArtifactLoading;
